import apiHelper from '../helpers/apiHelper'

export default {
  enableViaRedirect (returnTo) {
    return apiHelper.request('two-factor-auth/enable-via-redirect', { return_to: returnTo }, 'POST')
  },
  disableViaRedirect (returnTo) {
    return apiHelper.request('two-factor-auth/disable-via-redirect', { return_to: returnTo }, 'POST')
  },
  enable (password) {
    return apiHelper.request('two-factor-auth/enable', { password }, 'POST')
  },
  disable (password, otp, recoveryCode) {
    const body = { password }
    if (otp) body.otp = otp
    if (recoveryCode) body.recovery_code = recoveryCode
    return apiHelper.request('two-factor-auth/disable', body, 'POST')
  },
  finalize () {
    return apiHelper.request('two-factor-auth/finalize', {}, 'POST')
  }
}
